import React from "react";
import { Table } from "semantic-ui-react";



import { formatISOToThaiDate } from "react-lib/utils/dateUtils";

const renderCreditCell = (amountStr: string) => {
  let amount =  Number(amountStr.replace(/,/g, ""))
  const isPlus = amount > 0
  let absCredit = Math.abs(amount)
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 12px",
        borderRadius: "999px",
        backgroundColor: isPlus ? "#e8f7e8" : "#fde8e8",
        color: isPlus ? "#149645" : "#c0392b",
        fontWeight: 600,
      }}
    >
      {isPlus ? "+" : "-"} {absCredit?.toFixed(2)}
    </div>
  );
};

const MeHealthCreditUsageTable = ({ rows }: { rows: any[] }) => (
  <div
    style={{
      border: "1px solid #f0f0f0",
      borderRadius: "12px",
      padding: "12px",
      maxHeight: "360px",
      overflowY: "auto",
    }}
  >
    <Table basic="very" celled={false} selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Order No.</Table.HeaderCell>
          <Table.HeaderCell>Date</Table.HeaderCell>
          <Table.HeaderCell>Credit Use</Table.HeaderCell>
          <Table.HeaderCell>Remark</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {rows.map((item) => (
          <Table.Row key={item.id}>
            <Table.Cell style={{ whiteSpace: "pre-line" }}>{item.credit_adjustment_item_name} <br/> {item.credit_adjustment_item_detail}</Table.Cell>
            <Table.Cell>{item.created_at ? formatISOToThaiDate(item.created_at) : ""}</Table.Cell>
            <Table.Cell>{renderCreditCell(item.amount)}</Table.Cell>
            <Table.Cell>{item.remark || "-"}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </div>
);

export default MeHealthCreditUsageTable;
